document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-countdown]').forEach(el=>{
    const end=new Date(el.dataset.countdown);
    const tick=()=>{
      let d=Math.max(0,end-new Date());
      const v=[Math.floor(d/864e5),Math.floor(d/36e5)%24,Math.floor(d/6e4)%60,Math.floor(d/1e3)%60];
      ['[data-d]','[data-h]','[data-m]','[data-s]'].forEach((s,i)=>{const n=el.querySelector(s);if(n)n.childNodes[0].nodeValue=String(v[i]).padStart(2,'0')});
    };
    tick();setInterval(tick,1000);
  });
  const b=document.querySelector('.mobile-menu'),n=document.querySelector('.site-header nav');
  if(b&&n)b.onclick=()=>{const isOpen=n.classList.toggle('open');b.setAttribute('aria-expanded',isOpen?'true':'false');};
});

function acxoraUpdateDailySaleTimers(scope){
  const root=scope||document;
  const timers=[];
  if(root.matches&&root.matches('[data-daily-sale-timer]'))timers.push(root);
  if(root.querySelectorAll)timers.push(...root.querySelectorAll('[data-daily-sale-timer]'));
  if(!timers.length)return;
  const now=new Date();
  const end=new Date(now);
  end.setHours(24,0,0,0);
  const total=Math.max(0,Math.floor((end.getTime()-now.getTime())/1000));
  const hours=Math.floor(total/3600);
  const minutes=Math.floor(total/60)%60;
  const seconds=total%60;
  const text=String(hours).padStart(2,'0')+':'+String(minutes).padStart(2,'0')+':'+String(seconds).padStart(2,'0');
  timers.forEach(timer=>{
    const clock=timer.querySelector('[data-daily-sale-clock]');
    if(clock)clock.textContent=text;
  });
}

document.addEventListener('DOMContentLoaded',()=>{
  acxoraUpdateDailySaleTimers(document);
  window.setInterval(()=>acxoraUpdateDailySaleTimers(document),1000);
});
document.addEventListener('shopify:section:load',event=>acxoraUpdateDailySaleTimers(event.target));

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const track=gallery.querySelector('[data-gallery-track]');
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    const dots=[...gallery.querySelectorAll('[data-gallery-dot]')];
    const current=gallery.querySelector('[data-gallery-current]');
    const prev=gallery.querySelector('[data-gallery-prev]');
    const next=gallery.querySelector('[data-gallery-next]');
    if(!track||!slides.length)return;
    let active=0;
    const setActive=index=>{
      active=Math.max(0,Math.min(index,slides.length-1));
      gallery.dataset.activeIndex=String(active);
      thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===active));
      dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===active));
      if(current)current.textContent=String(active+1);
      if(thumbs[active])thumbs[active].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    };
    const goTo=index=>{
      const target=Math.max(0,Math.min(index,slides.length-1));
      slides[target].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
      setActive(target);
    };
    gallery._goTo=goTo;
    gallery._getActiveSlide=()=>slides[active]||slides[0];
    setActive(0);
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>goTo(i)));
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>goTo(i)));
    if(prev)prev.addEventListener('click',()=>goTo(active===0?slides.length-1:active-1));
    if(next)next.addEventListener('click',()=>goTo(active===slides.length-1?0:active+1));
    let raf;
    track.addEventListener('scroll',()=>{
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>{
        const index=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
        if(index!==active)setActive(index);
      });
    },{passive:true});
  });
});

(function(){
  function getChatHosts(){
    const candidates=[
      document.querySelector('inbox-online-store-chat'),
      document.querySelector('inbox-online-store-chat#ShopifyChat'),
      document.getElementById('ShopifyChat'),
      document.querySelector('shopify-chat')
    ].filter(Boolean);
    return [...new Set(candidates)];
  }

  function findChatActivator(){
    const selectors=[
      'button.chat-toggle',
      '.chat-app > button',
      '[data-spec="toggle-button"]',
      'button.activator',
      '[part="activator"]',
      'button[aria-label*="chat" i]',
      'button[title*="chat" i]'
    ];
    const visited=new Set();
    function walk(node){
      if(!node || visited.has(node)) return null;
      visited.add(node);
      for(const selector of selectors){
        try{const found=node.querySelector&&node.querySelector(selector);if(found)return found;}catch(e){}
      }
      let all=[];
      try{all=node.querySelectorAll?[...node.querySelectorAll('*')]:[];}catch(e){all=[];}
      for(const el of all){
        if(el.shadowRoot){const found=walk(el.shadowRoot);if(found)return found;}
      }
      return null;
    }
    for(const host of getChatHosts()){
      if(host.getAttribute && host.getAttribute('is-open')==='true') return {alreadyOpen:true};
      const found=walk(host.shadowRoot||host);
      if(found)return found;
    }
    return null;
  }

  function clickDummyChatButton(){
    const iframe=document.getElementById('dummy-chat-button-iframe');
    if(!iframe)return false;
    try{
      const doc=iframe.contentDocument||(iframe.contentWindow&&iframe.contentWindow.document);
      const button=doc&&(doc.getElementById('dummy-chat-button')||doc.querySelector('button'));
      if(button){button.click();return true;}
    }catch(e){}
    return false;
  }

  function openStoreChat(status,fallbackText,attempt){
    attempt=attempt||0;
    try{
      if(window.ShopifyChat&&typeof window.ShopifyChat.open==='function'){window.ShopifyChat.open();return true;}
      if(window.ShopifyInbox&&typeof window.ShopifyInbox.open==='function'){window.ShopifyInbox.open();return true;}
    }catch(e){}
    const activator=findChatActivator();
    if(activator&&activator.alreadyOpen)return true;
    if(activator&&typeof activator.click==='function'){
      try{activator.click();return true;}catch(e){}
    }
    if(clickDummyChatButton())return true;
    if(attempt<16){window.setTimeout(()=>openStoreChat(status,fallbackText,attempt+1),250);return false;}
    if(status){status.textContent=fallbackText||'Please use the Chat bubble on the page.';status.hidden=false;}
    return false;
  }

  function initPremiumProduct(root){
    if(!root || root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    const form = root.querySelector('.premium-product-form');
    const variantsScript = root.querySelector('[data-product-variants]');
    let variants = [];
    try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; } catch(e) { variants = []; }

    const variantIdInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-product-compare]');
    const discountEl = root.querySelector('[data-product-discount]');
    const saleMeta = root.querySelector('[data-product-sale-meta]');
    const saleByPrice = new Map();
    variants.forEach(v=>{
      const price=Number(v.price_cents||0);
      const compare=Number(v.compare_at_price_cents||0);
      if(compare>price){
        const current=saleByPrice.get(price);
        if(!current || compare>current.cents) saleByPrice.set(price,{cents:compare,text:v.compare_at_price||''});
      }
    });
    const saleCountdown = root.querySelector('[data-product-sale-countdown]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-to-cart-text]');
    const optionGroups = [...root.querySelectorAll('[data-variant-option]')].sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition));
    const buyNowGuard = root.querySelector('[data-buy-now-guard]');
    const dynamicCheckoutWrap = root.querySelector('[data-dynamic-checkout-wrap]');

    function requiredContainer(field){
      return field.closest('.personalization-details,.variant-option,.product-option-block,.delivery-destination,.logo-upload-block') || field.parentElement;
    }

    function fieldIsMissing(field){
      if(!field || field.disabled) return false;
      if(field.type === 'radio'){
        return !form.querySelector('input[type="radio"][name="'+CSS.escape(field.name)+'"]:checked');
      }
      if(field.type === 'checkbox') return field.required && !field.checked;
      if(field.type === 'file') return field.required && (!field.files || !field.files.length);
      return field.required && !String(field.value || '').trim();
    }

    function clearRequiredError(field){
      const container=requiredContainer(field);
      if(!container) return;
      const related = field.type === 'radio' ? form.querySelectorAll('input[type="radio"][name="'+CSS.escape(field.name)+'"]') : [field];
      let stillMissing=false;
      related.forEach(item=>{ if(fieldIsMissing(item)) stillMissing=true; });
      if(stillMissing) return;
      container.classList.remove('is-required-missing');
      container.querySelectorAll('[data-required-message]').forEach(el=>el.remove());
    }

    function showRequiredError(field){
      const container=requiredContainer(field);
      if(!container) return;
      if(container.tagName === 'DETAILS') container.open = true;
      container.classList.add('is-required-missing');
      if(!container.querySelector('[data-required-message]')){
        const message=document.createElement('small');
        message.className='required-field-message';
        message.dataset.requiredMessage='true';
        message.textContent='Required';
        const controlWrap=field.closest('.select-wrap') || field;
        if(controlWrap && controlWrap.parentNode) controlWrap.parentNode.insertBefore(message,controlWrap.nextSibling);
        else container.appendChild(message);
      }
    }

    function validateRequiredFields(opts={}){
      if(!form) return true;
      const fields=[...form.querySelectorAll('[required]')];
      const seenRadioNames=new Set();
      const missing=[];
      fields.forEach(field=>{
        if(field.type==='radio'){
          if(seenRadioNames.has(field.name)) return;
          seenRadioNames.add(field.name);
        }
        if(fieldIsMissing(field)) missing.push(field);
        else clearRequiredError(field);
      });
      if(missing.length){
        if(opts.showErrors!==false) missing.forEach(showRequiredError);
        if(opts.focus!==false && opts.showErrors!==false){
          const first=missing[0];
          const container=requiredContainer(first);
          if(container) container.scrollIntoView({behavior:'smooth',block:'center'});
          window.setTimeout(()=>{try{first.focus({preventScroll:true});}catch(e){try{first.focus();}catch(_){}}},250);
        }
        return false;
      }
      return true;
    }

    function updateCheckoutGuard(){
      if(!dynamicCheckoutWrap || !buyNowGuard) return;
      const isValid=validateRequiredFields({focus:false,showErrors:false});
      dynamicCheckoutWrap.classList.toggle('is-form-complete',isValid);
      buyNowGuard.setAttribute('aria-hidden','false');
      buyNowGuard.setAttribute('aria-label',isValid?'Review bag before checkout':'Complete required options before checkout');
    }

    function getSelectedOptions(){
      return optionGroups.map(group=>{
        const select = group.querySelector('[data-variant-select]');
        if(select) return select.value;
        const checked = group.querySelector('[data-variant-radio]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(){
      if(!variants.length) return null;
      if(!optionGroups.length) return variants.find(v=>String(v.id) === String(variantIdInput && variantIdInput.value)) || variants[0];
      const selected = getSelectedOptions();
      return variants.find(variant=>variant.options.every((value,index)=>String(value) === String(selected[index])));
    }

    function showVariantMedia(mediaId){
      if(!mediaId) return;
      const gallery = root.querySelector('[data-product-gallery]');
      if(!gallery) return;
      const slide = gallery.querySelector('[data-gallery-slide][data-media-id="'+mediaId+'"]');
      if(!slide) return;
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const index = slides.indexOf(slide);
      if(index < 0) return;
      if(typeof gallery._goTo === 'function') gallery._goTo(index);
      else slide.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    }

    function updateVariant(){
      const variant = findVariant();
      if(!variant){
        const selected=getSelectedOptions();
        const incomplete=selected.some(value=>!String(value||'').trim());
        if(incomplete){
          root.classList.remove('is-unavailable');
          if(addButton) addButton.disabled = false;
          if(addText) addText.textContent = addButton?.dataset.availableLabel || 'Add to cart';
        } else {
          root.classList.add('is-unavailable');
          if(addButton) addButton.disabled = true;
          if(addText) addText.textContent = addButton?.dataset.unavailableLabel || 'Unavailable';
        }
        return;
      }
      if(variantIdInput) variantIdInput.value = variant.id;
      if(priceEl) priceEl.textContent = variant.price || '';
      const priceCents=Number(variant.price_cents||0);
      const ownCompare=Number(variant.compare_at_price_cents||0);
      const fallbackSale=saleByPrice.get(priceCents);
      const compareCents=ownCompare>priceCents ? ownCompare : Number(fallbackSale?.cents||0);
      const compareText=ownCompare>priceCents ? (variant.compare_at_price||'') : (fallbackSale?.text||'');
      const hasSale = compareCents > priceCents;
      if(compareEl){compareEl.hidden = !hasSale;compareEl.textContent = hasSale ? compareText : '';}
      if(discountEl){
        if(hasSale){
          const pct = Math.round((compareCents-priceCents)*100/compareCents);
          discountEl.textContent = pct+'% off';
        } else discountEl.textContent = '';
      }
      if(saleMeta) saleMeta.hidden = !hasSale;
      if(addButton){
        addButton.disabled = !variant.available;
        if(addText) addText.textContent = variant.available ? (addButton.dataset.availableLabel || 'Add to cart') : (addButton.dataset.soldOutLabel || 'Sold out');
      }
      root.classList.toggle('is-unavailable', !variant.available);
      showVariantMedia(variant.featured_media_id);
      if(window.history && window.history.replaceState){
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({},'',url.toString());
      }
    }

    function revealChart(group){
      const chart=group && group.querySelector('[data-option-chart]');
      if(!chart)return;
      root.querySelectorAll('[data-option-chart]').forEach(other=>{if(other!==chart)other.hidden=true;});
      chart.hidden=false;
    }

    optionGroups.forEach(group=>{
      group.addEventListener('change',()=>{updateVariant();revealChart(group);});
      const select=group.querySelector('[data-variant-select]');
      if(select){
        select.addEventListener('pointerdown',()=>revealChart(group));
        select.addEventListener('focus',()=>revealChart(group));
      }
      group.querySelectorAll('[data-chart-close]').forEach(button=>button.addEventListener('click',event=>{
        event.preventDefault();event.stopPropagation();
        const chart=button.closest('[data-option-chart]');if(chart)chart.hidden=true;
      }));
    });
    updateVariant();

    function cartRoot(){
      return (window.Shopify&&Shopify.routes&&Shopify.routes.root) ? Shopify.routes.root : '/';
    }

    function showCartError(message){
      if(!form) return;
      let error=form.querySelector('[data-cart-add-error]');
      if(!error){
        error=document.createElement('p');
        error.dataset.cartAddError='true';
        error.className='cart-add-error';
        const buttons=form.querySelector('.buy-buttons');
        if(buttons) buttons.appendChild(error); else form.appendChild(error);
      }
      error.textContent=message||'We could not add this item. Please try again.';
      error.hidden=false;
    }

    function resetCartSubmitState(){
      if(!form) return;
      delete form.dataset.cartSubmitting;
      if(addButton){
        addButton.removeAttribute('aria-busy');
        const variant=findVariant();
        addButton.disabled=variant ? !variant.available : false;
      }
      if(dynamicCheckoutWrap) dynamicCheckoutWrap.classList.remove('is-redirecting');
      if(addText){
        const variant=findVariant();
        addText.textContent=(variant && !variant.available)
          ? (addButton?.dataset.soldOutLabel || 'Sold out')
          : (addButton?.dataset.availableLabel || 'Add to cart');
      }
    }

    function prepareNativeCartSubmit(){
      if(!form || form.dataset.cartSubmitting==='true') return false;
      if(!validateRequiredFields({focus:true})){
        updateCheckoutGuard();
        return false;
      }
      // Keep the purchase buttons visually unchanged while Shopify submits.
      // The guard prevents accidental duplicate submits without disabling the UI.
      form.dataset.cartSubmitting='true';
      const existingError=form.querySelector('[data-cart-add-error]');
      if(existingError) existingError.hidden=true;
      return true;
    }

    // Browsers can restore the product page from back/forward cache after a cart visit.
    // Always return the buttons to their normal, clickable state when the page is shown again.
    window.addEventListener('pageshow',resetCartSubmitState);

    if(form){
      form.querySelectorAll('[required]').forEach(field=>{
        ['input','change'].forEach(eventName=>field.addEventListener(eventName,()=>{
          clearRequiredError(field);
          updateCheckoutGuard();
        }));
      });
      form.addEventListener('submit',event=>{
        if(!prepareNativeCartSubmit()){
          event.preventDefault();
          event.stopPropagation();
        }
        // On a valid submit we deliberately allow Shopify's native product form
        // POST to /cart/add. The Liquid form uses return_to: routes.cart_url,
        // so Shopify adds the line item and then opens the cart page.
      },true);
    }
    if(addButton){
      addButton.addEventListener('click',event=>{
        if(!validateRequiredFields({focus:true})){
          event.preventDefault();
          event.stopPropagation();
          updateCheckoutGuard();
        }
      },true);
    }
    if(buyNowGuard){
      buyNowGuard.addEventListener('click',event=>{
        event.preventDefault();
        event.stopPropagation();
        if(!validateRequiredFields({focus:true})){
          updateCheckoutGuard();
          return;
        }
        if(form.requestSubmit) form.requestSubmit(addButton || undefined);
        else if(addButton) addButton.click();
        else form.submit();
      });
    }
    updateCheckoutGuard();

    if(saleCountdown) acxoraUpdateDailySaleTimers(saleCountdown);

    root.querySelectorAll('[data-quantity-selector]').forEach(selector=>{
      const input = selector.querySelector('[data-quantity-input]');
      const minus = selector.querySelector('[data-quantity-minus]');
      const plus = selector.querySelector('[data-quantity-plus]');
      if(!input) return;
      const normalize=()=>{ input.value = Math.max(1, parseInt(input.value || '1',10) || 1); };
      const notify=()=>{input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));};
      if(minus) minus.addEventListener('click',()=>{ normalize(); input.value=Math.max(1,Number(input.value)-1); notify(); });
      if(plus) plus.addEventListener('click',()=>{ normalize(); input.value=Number(input.value)+1; notify(); });
      input.addEventListener('change',normalize);
    });

    root.querySelectorAll('[data-shipping-estimator]').forEach(estimator=>{
      const price=estimator.querySelector('[data-shipping-price]');
      const country=estimator.querySelector('[data-shipping-country]');
      const toggle=estimator.querySelector('[data-expedited-toggle]');
      const expeditedQuote=estimator.querySelector('[data-expedited-quote]');
      const preference=estimator.querySelector('[data-shipping-preference]');
      const ranges=estimator.querySelectorAll('[data-delivery-range]');
      const titleRanges=root.querySelectorAll('[data-title-delivery-range]');
      const titleDeliveryNote=root.querySelector('[data-title-delivery-note]');
      const symbol=estimator.dataset.currencySymbol||'$';
      const freeShipping=estimator.dataset.freeShipping==='true';
      const parsedBase=Number(estimator.dataset.standardBase);
      const base=freeShipping?0:(Number.isFinite(parsedBase)?parsedBase:496);
      const parsedInternationalBase=Number(estimator.dataset.internationalBase);
      const internationalBase=freeShipping?0:(Number.isFinite(parsedInternationalBase)?parsedInternationalBase:base);
      const standardCountries=String(estimator.dataset.standardCountries||'').split(',').map(v=>v.trim()).filter(Boolean);
      const money=cents=>symbol+(Number(cents||0)/100).toFixed(2);
      const dateLabel=(minDays,maxDays)=>{
        const now=new Date();
        const a=new Date(now); a.setDate(a.getDate()+minDays);
        const b=new Date(now); b.setDate(b.getDate()+maxDays);
        const monthA=a.toLocaleString(undefined,{month:'short'});
        const monthB=b.toLocaleString(undefined,{month:'short'});
        if(a.getFullYear()!==b.getFullYear()) return a.toLocaleDateString(undefined,{day:'numeric',month:'short',year:'numeric'})+' – '+b.toLocaleDateString(undefined,{day:'numeric',month:'short',year:'numeric'});
        if(monthA===monthB) return a.getDate()+'–'+b.getDate()+' '+monthA;
        return a.getDate()+' '+monthA+' – '+b.getDate()+' '+monthB;
      };
      const update=()=>{
        const selectedCountry=country?String(country.value||'').trim():'';
        const selectedRate=selectedCountry && standardCountries.length && !standardCountries.includes(selectedCountry) ? internationalBase : base;
        if(price)price.textContent=freeShipping?'Free':money(selectedRate);
        const minDays=Math.max(1,parseInt(estimator.dataset.deliveryMinDays||'8',10)||8);
        const maxDays=Math.max(minDays,parseInt(estimator.dataset.deliveryMaxDays||'12',10)||12);
        const deliveryText=dateLabel(minDays,maxDays);
        ranges.forEach(el=>{el.textContent=deliveryText;});
        titleRanges.forEach(el=>{el.textContent=deliveryText;});
        if(titleDeliveryNote) titleDeliveryNote.hidden=false;
        if(expeditedQuote) expeditedQuote.hidden=!(toggle&&toggle.checked);
        if(preference)preference.value=(toggle&&toggle.checked)?'Expedited requested':'Standard';
      };
      if(country)country.addEventListener('change',update);
      if(toggle)toggle.addEventListener('change',update);
      update();
    });

    root.querySelectorAll('[data-open-store-chat]').forEach(button=>button.addEventListener('click',event=>{
      event.preventDefault();
      event.stopPropagation();
      const status=button.parentElement && button.parentElement.querySelector('[data-chat-status]');
      if(status) status.hidden=true;
      openStoreChat(status,button.dataset.chatFallback,0);
    }));

    const actionToast=root.querySelector('[data-gallery-action-toast]');
    let actionToastTimer;
    const showGalleryToast=message=>{
      if(!actionToast)return;
      clearTimeout(actionToastTimer);
      actionToast.textContent=message;
      actionToast.hidden=false;
      actionToastTimer=setTimeout(()=>{actionToast.hidden=true;},2200);
    };

    root.querySelectorAll('[data-product-share]').forEach(button=>button.addEventListener('click',async event=>{
      event.preventDefault();
      const url=button.dataset.shareUrl||window.location.href;
      const title=button.dataset.shareTitle||document.title;
      try{
        if(navigator.share){
          await navigator.share({title,url});
        }else if(navigator.clipboard&&navigator.clipboard.writeText){
          await navigator.clipboard.writeText(url);
          showGalleryToast('Product link copied');
        }else{
          const temp=document.createElement('input');temp.value=url;document.body.appendChild(temp);temp.select();document.execCommand('copy');temp.remove();showGalleryToast('Product link copied');
        }
      }catch(err){if(err&&err.name!=='AbortError')showGalleryToast('Copy the page link to share');}
    }));

    const wishlistKey='acxoraWishlist';
    const readWishlist=()=>{try{return JSON.parse(localStorage.getItem(wishlistKey)||'[]')}catch(e){return[]}};
    const writeWishlist=items=>{try{localStorage.setItem(wishlistKey,JSON.stringify(items))}catch(e){}};
    root.querySelectorAll('[data-product-wishlist]').forEach(button=>{
      const handle=button.dataset.productHandle;
      const refresh=()=>{
        const saved=readWishlist().some(item=>item&&item.handle===handle);
        button.classList.toggle('is-active',saved);
        button.setAttribute('aria-pressed',saved?'true':'false');
        button.setAttribute('aria-label',saved?'Remove from wishlist':'Add to wishlist');
        button.title=saved?'Remove from wishlist':'Add to wishlist';
      };
      refresh();
      button.addEventListener('click',event=>{
        event.preventDefault();
        let items=readWishlist();
        const index=items.findIndex(item=>item&&item.handle===handle);
        if(index>=0){items.splice(index,1);writeWishlist(items);showGalleryToast('Removed from wishlist');}
        else{
          items.push({handle,title:button.dataset.productTitle||'',url:button.dataset.productUrl||'',image:button.dataset.productImage||''});
          writeWishlist(items);showGalleryToast('Saved to wishlist');
        }
        refresh();
      });
    });

    // Customer review photo carousel + lightbox
    const reviewLightbox=root.querySelector('[data-review-lightbox]');
    const reviewLightboxImage=reviewLightbox&&reviewLightbox.querySelector('[data-review-lightbox-image]');
    const reviewPhotoButtons=[...root.querySelectorAll('[data-review-photo]')];
    let activeReviewPhotoIndex=0;
    const reviewPhotoSrcs=reviewPhotoButtons.map(button=>button.dataset.reviewSrc||button.querySelector('img')?.src||'').filter(Boolean);
    const showReviewPhoto=index=>{
      if(!reviewLightbox||!reviewLightboxImage||!reviewPhotoSrcs.length)return;
      activeReviewPhotoIndex=(index+reviewPhotoSrcs.length)%reviewPhotoSrcs.length;
      reviewLightboxImage.src=reviewPhotoSrcs[activeReviewPhotoIndex];
      reviewLightbox.hidden=false;
      document.body.classList.add('review-lightbox-open');
      const close=reviewLightbox.querySelector('[data-review-lightbox-close]');
      if(close)close.focus();
    };
    const closeReviewPhoto=()=>{
      if(!reviewLightbox)return;
      reviewLightbox.hidden=true;
      if(reviewLightboxImage)reviewLightboxImage.src='';
      document.body.classList.remove('review-lightbox-open');
    };
    reviewPhotoButtons.forEach((button,index)=>button.addEventListener('click',event=>{
      event.preventDefault();
      const src=button.dataset.reviewSrc||button.querySelector('img')?.src||'';
      const actualIndex=reviewPhotoSrcs.indexOf(src);
      showReviewPhoto(actualIndex>=0?actualIndex:index);
    }));
    if(reviewLightbox){
      const prev=reviewLightbox.querySelector('[data-review-lightbox-prev]');
      const next=reviewLightbox.querySelector('[data-review-lightbox-next]');
      const close=reviewLightbox.querySelector('[data-review-lightbox-close]');
      if(prev)prev.addEventListener('click',()=>showReviewPhoto(activeReviewPhotoIndex-1));
      if(next)next.addEventListener('click',()=>showReviewPhoto(activeReviewPhotoIndex+1));
      if(close)close.addEventListener('click',closeReviewPhoto);
      reviewLightbox.addEventListener('click',event=>{if(event.target===reviewLightbox)closeReviewPhoto();});
      document.addEventListener('keydown',event=>{
        if(reviewLightbox.hidden)return;
        if(event.key==='Escape')closeReviewPhoto();
        if(event.key==='ArrowLeft')showReviewPhoto(activeReviewPhotoIndex-1);
        if(event.key==='ArrowRight')showReviewPhoto(activeReviewPhotoIndex+1);
      });
    }
    root.querySelectorAll('[data-review-photo-strip]').forEach(strip=>{
      const wrap=strip.closest('[data-review-strip-wrap]') || strip.parentElement;
      const prev=wrap&&wrap.querySelector('[data-review-strip-prev]');
      const next=wrap&&wrap.querySelector('[data-review-strip-next]');
      const scrollByAmount=()=>Math.max(strip.clientWidth*.72,180);
      if(prev)prev.addEventListener('click',()=>strip.scrollBy({left:-scrollByAmount(),behavior:'smooth'}));
      if(next)next.addEventListener('click',()=>strip.scrollBy({left:scrollByAmount(),behavior:'smooth'}));
    });

    const zoomModal=root.querySelector('[data-product-zoom]');
    const zoomImage=root.querySelector('[data-zoom-modal-image]');
    const gallery=root.querySelector('[data-product-gallery]');
    if(zoomModal&&zoomImage&&gallery){
      const openZoom=slide=>{
        const target=slide || (typeof gallery._getActiveSlide==='function'?gallery._getActiveSlide():gallery.querySelector('[data-gallery-slide]'));
        if(!target)return;
        const src=target.dataset.zoomSrc;
        const sourceImage=target.querySelector('img');
        if(!src)return;
        zoomImage.src=src;
        zoomImage.alt=sourceImage?sourceImage.alt:'';
        zoomModal.hidden=false;
        document.body.classList.add('product-zoom-open');
        const close=zoomModal.querySelector('[data-zoom-close]');if(close)close.focus();
      };
      const closeZoom=()=>{zoomModal.hidden=true;zoomImage.src='';document.body.classList.remove('product-zoom-open');};
      gallery.querySelectorAll('[data-gallery-slide]').forEach(slide=>{
        const img=slide.querySelector('.gallery-main-image');if(img)img.addEventListener('click',()=>openZoom(slide));
      });
      const zoomButton=gallery.querySelector('[data-gallery-zoom-button]');if(zoomButton)zoomButton.addEventListener('click',()=>openZoom());
      zoomModal.querySelectorAll('[data-zoom-close]').forEach(button=>button.addEventListener('click',closeZoom));
      zoomModal.addEventListener('click',event=>{if(event.target===zoomModal)closeZoom();});
      document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!zoomModal.hidden)closeZoom();});
    }
  }

  function initAllPremiumProducts(scope){
    const root = scope || document;
    if(root.matches && root.matches('[data-premium-product]')) initPremiumProduct(root);
    root.querySelectorAll && root.querySelectorAll('[data-premium-product]').forEach(initPremiumProduct);
  }

  document.addEventListener('DOMContentLoaded',()=>initAllPremiumProducts(document));
  document.addEventListener('shopify:section:load',event=>initAllPremiumProducts(event.target));
})();
